import {Payload} from "../../../../../core/service/payload/payload";

export class SaleDeleteProductActionPayload implements Payload {

    saleId: number;
    saleProductId: number;
}